import AxiosInstance from "../instance";

const getFearAndGreedIndex = async () => {
    const response = await AxiosInstance.getInstance().get("/groupapi/fear-greed-index");

    return response;
};

export {getFearAndGreedIndex};


// WEBPACK FOOTER //
// ./src/api/models/FearAndGreedIndex.ts